import Vue from 'vue'

import TgStoreLocator from '@topgeschenken/webshop-front/components/store_locator/TgStoreLocator'

import 'bootstrap/dist/css/bootstrap.min.css';
import './../scss/store-locator.scss';
import {initializeVueComponent} from "../utils/vue";

Vue.config.productionTip = false;

(() => {
  initializeVueComponent('#store_locator_app', TgStoreLocator)
})();
